export const languageCultureMap = {
  en: 'en-US',
  es: 'es-ES',
  fr: 'fr-FR',
  de: 'de-DE',
  pt: 'pt-BR',
  az: 'az-Latn-AZ'
} as const;
